export default __webpack_public_path__ + "static/media/ic-schedule.19b169da.svg";